<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Projectleider rapport - Inzet ploegen per week</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>
<div class="dialog-content" mat-dialog-content>
    <table class="table table-bordered table-striped text-right table-hover">
        <tr>
            <th>Projectleider</th>
            @for (week of weeks; track week) {
                <th>
                    Week {{ week.startDate | date: 'w' }}<br />
                    <small>
                        {{ week.startDate | date: 'EEE dd MMM y' }}<br />
                        {{ week.endDate | date: 'EEE dd MMM y' }}
                    </small>
                </th>
            }
        </tr>
        @for (projectManager of projectManagers; track projectManager) {
            <tr>
                <td class="text-left">
                    {{ projectManager.name }}
                </td>
                @for (week of weeks; track week) {
                    <td class="text-center">
                        <div class="stat">
                            @for (date of week.dates; track date) {
                                @if (reportMap.has('' + projectManager.id + '_' + date)) {
                                    <div></div>
                                }
                            }
                        </div>
                    </td>
                }
            </tr>
        }
    </table>
</div>
